export enum UpsertCheckoutActiveStep {
  Detail = "Detail",
  Sell = "Sell",
  Pay = "Pay",
  AfterPay = "After Pay",
  Options = "Options",
}
export enum CheckOutButtonStyle {
  SquareRoundCorner = "SquareRoundCorner",
  Square = "Square",
  Round = "Round",
}
export enum CheckOutPayButtonCaption {
  Pay = "Pay",
  Try = "Try",
  Book = "Book",
  Donate = "Donate",
  Purchase = "Purchase",
  Order = "Order",
  Register = "Register",
  PurchaseAndSubscribe = "Purchase & Subscribe",
  Subscribe = "Subscribe",
  Custom = "Custom",
}
export enum CheckOutDefaultSegmentType {
  OneTime = "One Time",
}
export enum CheckOutHelpType {
  Phone = "Phone",
  Email = "Email",
}
export enum CheckoutColorType {
  BasicColor = "BasicColor",
  CustomColor = "CustomColor",
}
export enum ImagePlacementTypes {
  Left = "Left",
  Right = "Right",
  Background = "Background",
}

export enum ImageFormatTypes {
  Original = "Original",
  ScreenFit = "ScreenFit",
}
export enum CheckOutDisplayTypes {
  SingleItem = "SingleItem",
  SingleItemWithMultiplePrices = "SingleItemWithMultiplePrices",
  MultipleItems = "MultipleItems",
  MultipleItemsInbundle = "MultipleItemsInbundle",
}

export enum PaymentMethodTypes {
  CreditDebitCard = "Credit / Debit Card",
  Bank = "Bank",
  ApplePay = "Apple Pay",
  GooglePay = "Google Pay",
  CheckWire = "Check / Wire",
}
export enum CheckOutPayFields {
  FirstLastName = "FirstLastName",
  EmailAddress = "EmailAddress",
  MobileNumber = "MobileNumber",
  Birthday = "Birthday",
  RenewalDate = "RenewalDate",
  TaxId = "TaxId",
}

export enum CheckOutPromoCodeSelectionType {
  AllActiveCodes = "AllActiveCodes",
  SelectCodes = "SelectCodes",
  ApplyCode = "ApplyCode",
}

export enum CheckOutRedirectTypes {
  Website = "Redirect to Website",
  ClickToEmail = "Click to Email",
  ClickToCall = "Click to Call",
  ClickToText = "Click to Text",
}

export enum CheckOutRedirectOption {
  None = "None",
  Message = "Message",
  Redirect = "Redirect",
}

export enum SellerTermsAndConditionsType {
  DisplayOnly = "Display Only",
  DoNotDisplay = "Do Not Display",
  RequireAcceptance = "Require Acceptance",
}

export enum SellerReturnPolicyType {
  DisplayOnly = "Display Only",
  DoNotDisplay = "Do Not Display",
  RequireAcceptance = "Require Acceptance",
}

export enum SurchargeType {
  IncludeSurcharge = "Include Surcharge",
  AskPermission = "Ask Permission",
  NoSurcharge = "No Surcharge",
}
